import { Skeleton } from "primereact/skeleton";
import React from "react";
import { useSelector } from "react-redux";
import { Link } from "react-router-dom";

const HeaderDefaultToPage = ({ 
  title,
  goBack = true, 
  children = null 
}) => {
  const isModalPage = useSelector(state => state.Layout.isModalPage)

  if(isModalPage) return <></>

  return (
    <div
      id="header-default-body"
      className="d-flex flex-row justify-content-between align-items-baseline mb-3"
    >
      <div className="d-flex align-items-baseline gap-2">
        {goBack && <Link onClick={() => window.history.back()}></Link>}

        {title ? (
          <h3 className="font-size-24 text-color-azul1 font-w-600 p-0 m-0">
            {title}
          </h3>
        ) : (
          <Skeleton width={400} height={55} className="mb-3" />
        )}
      </div>
      
      {children && (
        <div className="d-flex align-items-baseline">
          {children}
        </div>
      )}
            
    </div>
  );
};

export default HeaderDefaultToPage;
